<template>
  <div>
    <!-- <div class="top-bar" v-if="this.$vuetify.breakpoint.lgAndUp">
      <ul class="nav-listing">
                    <li>
                      <a    @click="$router.push({name:'innerpage.team'})" title="Our Teams">Our Team</a>
                    </li>
                    <li>
                      <a    @click="$router.push( {name:'innerpage.partners'})"   title="Investors">Partners / Alliances</a>
                    </li>
                    

                    <li>
                      <a    @click="$router.push({name:'innerpage.career'})" title="Career">Career</a>
                    </li>
                    

              </ul>
    </div>-->
    <v-toolbar height="53" color="white" class="elevation-1" style="z-index:5;">
      <v-toolbar-title class="d-flex logo-inner">
        <a href="/" title="spice logo" style="display:flex; align-items:center;">
          <img :src="require('@/assets/images/spice-logo.png')" width="160px" alt="Spice Logo" />
        </a>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="social-icons" v-if="this.$vuetify.breakpoint.smAndUp">
        <a href="https://www.facebook.com/SpiceMoneyOfficial" target="_blank">
          <svg style="width:32px;height:32px" viewBox="0 0 24 24">
            <path
              fill="#475993"
              d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z"
            />
          </svg>
        </a>
        <a href="https://twitter.com/SpiceMoneyIndia" target="_blank">
          <svg style="width:32px;height:32px" viewBox="0 0 24 24">
            <path
              fill="#76a9ea"
              d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M17.71,9.33C18.19,8.93 18.75,8.45 19,7.92C18.59,8.13 18.1,8.26 17.56,8.33C18.06,7.97 18.47,7.5 18.68,6.86C18.16,7.14 17.63,7.38 16.97,7.5C15.42,5.63 11.71,7.15 12.37,9.95C9.76,9.79 8.17,8.61 6.85,7.16C6.1,8.38 6.75,10.23 7.64,10.74C7.18,10.71 6.83,10.57 6.5,10.41C6.54,11.95 7.39,12.69 8.58,13.09C8.22,13.16 7.82,13.18 7.44,13.12C7.81,14.19 8.58,14.86 9.9,15C9,15.76 7.34,16.29 6,16.08C7.15,16.81 8.46,17.39 10.28,17.31C14.69,17.11 17.64,13.95 17.71,9.33Z"
            />
          </svg>
        </a>
        <a href="https://www.instagram.com/spicemoneyofficial" target="_blank">
          <svg style="width:32px;height:32px" viewBox="0 0 24 24">
            <path
              fill="#c3256b"
              d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
            />
          </svg>
        </a>
        <a href="https://www.linkedin.com/company/spicemoneybharat/" target="_blank">
          <svg style="width:32px;height:32px" viewBox="0 0 24 24">
            <path
              fill="#0077b7"
              d="M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M18.5,18.5V13.2A3.26,3.26 0 0,0 15.24,9.94C14.39,9.94 13.4,10.46 12.92,11.24V10.13H10.13V18.5H12.92V13.57C12.92,12.8 13.54,12.17 14.31,12.17A1.4,1.4 0 0,1 15.71,13.57V18.5H18.5M6.88,8.56A1.68,1.68 0 0,0 8.56,6.88C8.56,5.95 7.81,5.19 6.88,5.19A1.69,1.69 0 0,0 5.19,6.88C5.19,7.81 5.95,8.56 6.88,8.56M8.27,18.5V10.13H5.5V18.5H8.27Z"
            />
          </svg>
        </a>
        <a href="https://www.youtube.com/channel/UCoYrao7bUqM8v4nI6iUk_Xw" target="_blank">
          <svg style="width:34px;height:34px" viewBox="0 0 24 24">
            <path
              fill="#f00"
              d="M2.5,4.5H21.5C22.34,4.5 23,5.15 23,6V17.5C23,18.35 22.34,19 21.5,19H2.5C1.65,19 1,18.35 1,17.5V6C1,5.15 1.65,4.5 2.5,4.5M9.71,8.5V15L15.42,11.7L9.71,8.5M17.25,21H6.65C6.35,21 6.15,20.8 6.15,20.5C6.15,20.2 6.35,20 6.65,20H17.35C17.65,20 17.85,20.2 17.85,20.5C17.85,20.8 17.55,21 17.25,21Z"
            />
          </svg>
        </a>
      </div>
      <v-spacer></v-spacer>
      <v-btn flat icon color="primary" v-if="this.$vuetify.breakpoint.mdAndDown" @click="showNav">
        <v-icon>menu</v-icon>
      </v-btn>
      <ul class="nav-listing" v-if="this.$vuetify.breakpoint.lgAndUp">
        <li>
          <a href="/" title=" Spice Money">
            <v-icon color="primary">home</v-icon>
          </a>
        </li>
        <li>
          <a href="/spice-money-about" title="About Spice Money">
            About Us
            <v-icon size="19">arrow_drop_down</v-icon>
          </a>

          <ul>
            <li>
              <a href="/spice-money-ourJourney" title="Our Journey">Our Journey</a>
            </li>
            <!-- <li>
              <a href="/spice-money-team" title="Management Team">Management Team</a>
            </li>-->
            <li>
              <a href="/spice-money-products" title="Product & Services">Product & Services</a>
            </li>
            <li>
              <a href="/spice-money-partners" title="Investors">Partners and Alliances</a>
            </li>
          </ul>
        </li>

        <!-- <li>
                      <a    @click="$router.push({name:'innerpage.joinNow'})" title="Join Now">Join Us</a>
        </li>-->
        <li>
          <a href="/spice-money-career" title="Career">Careers</a>
        </li>
        <li>
          <a href="https://blog.spicemoney.com/" title="Blog">Blog</a>
        </li>
        <li>
          <svg style="width:20px;height:20px" class="contact-ico" viewBox="0 0 24 24">
            <path
              fill="#595e61"
              d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"
            />
          </svg>
          <a href="/spice-money-contact" title="Contact Spice Money">Contact Us</a>
        </li>
      </ul>
    </v-toolbar>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: rgb(245, 245, 245);
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 5px;
  position: relative;
}
.nav-listing li a {
  text-decoration: none;
  padding: 0px 10px;
  line-height: normal;
  vertical-align: middle;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}
.nav-listing li ul {
  overflow: hidden;
  position: absolute;
  margin: 0 !important;
  padding: 0;
  left: 0;
  height: 0px;
  top: 39px;
  list-style: none;
  white-space: nowrap;
  background: #fff;
  transition: all ease-in-out 0.4s;
}
.nav-listing li:hover ul {
  height: 155px;
}
.nav-listing li ul li {
  margin: 0;
  border-top: solid 1px #f2f2f2;
}
.nav-listing li ul li a {
  margin: 0;
  width: 100%;
  padding: 15px 25px;
  box-sizing: border-box;
  display: inline-block;
}
.inner-content {
  padding: 70px;
}

.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 30px 0 0 0;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: #ff7a00;
  border: 3px solid #ff7a00;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  line-height: 0;
  padding: 1.9em;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 120px;
  height: 120px;
  margin-right: 8%;
  animation: categoryTriggerPulse 3s infinite;
}

.icon-triggers li:before,
.icon-triggers li:after {
  content: "";
  display: block;
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.icon-triggers li:before {
  border: 2px solid #ff7a00;
}

.icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
}

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

.standard-listing {
  color: #ff7a00;
}
.standard-listing li {
  float: left;
  width: 50%;
}
.top-bar {
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;
  background: #f6f6f6;
}
.top-bar .nav-listing {
  padding: 3px 0 7px;
}
.top-bar .nav-listing a {
  font-size: 14px;
}
ul,
ol {
  margin: 0 !important;
}
.social-icons {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
}
.social-icons a {
  display: inline-flex;
  margin: 0 5px;
}
.social-icons a:first-child {
  margin-left: 0;
}
.contact-ico{
      vertical-align: middle;
    margin: 0 -9px 0 5px;
}
</style>

<script>
import InnerHeader from "./InnerHeader.ts";
export default InnerHeader;
</script>